import { gql } from '@apollo/client';

export const QUERY_BADGE_ASSIGNMENTS_BY_FEED = gql`
	query QueryBadgeAssignmentsByFeed(
		$companyId: ID!
		$feedType: FeedType!
		$subCompanyId: ID
		$tags: [String]
		$excludeAutomated: Boolean
		$limit: Int
		$nextToken: String
	) {
		queryBadgeAssignmentsByFeed(
			companyId: $companyId
			feedType: $feedType
			subCompanyId: $subCompanyId
			tags: $tags
			excludeAutomated: $excludeAutomated
			limit: $limit
			nextToken: $nextToken
		) {
			items {
				accountClaimId
				accountClaim {
					id
					firstName
					lastName
					emailAddress
					subCompany
					department
					employeeId
					userId
				}
				approvalStatus
				quietDecline
				awardedBy
				awardedByUser {
					id
					firstName
					lastName
					avatarSignedUrl
					milestoneYears
					departmentId
					userGroupId
					subCompanyId
				}
				id
				badgeId
				badge {
					id
					name
					badgeType {
						code
					}
					badgeTypeId
					color
					description
					gradientColor
					iconId
					icon {
						code
					}
					image
					label
					isAssignmentRestricted
					shape
					category
					badgeRotation
					customImageKey
					customImageSignedUrl
					labelColor
					customIconKey
					customIconSignedUrl
					milestoneRewardId
					milestoneReward {
						id
						name
						image
					}
				}
				comments
				commentsList {
					userId
					message
					createdAt
					firstName
					lastName
					user {
						avatarSignedUrl
						milestoneYears
					}
				}
				content {
					message
					gifURL
					tags
				}
				recipients {
					accountClaimId
					accountClaim {
						id
						firstName
						lastName
						emailAddress
						subCompany
						department
						employeeId
						userId
					}
					userId
					user {
						id
						firstName
						lastName
						departmentId
						subCompanyId
						userGroupId
					}
				}
				isPrivate
				rewardBonus
				points
				companyId
				createdAt
				totalClaps
				hasClappedUsers {
					id
					firstName
					lastName
				}
				userId
				user {
					id
					firstName
					lastName
					departmentId
					subCompanyId
					userGroupId
				}
			}
			nextToken
		}
	}
`;
